import SignRiskFormError from './SignRiskFormError';
class RiskFormAlreadySigned extends SignRiskFormError {
    constructor(options) {
        super('Risk form is already signed', options);
    }
}
export default RiskFormAlreadySigned;
